<template>
    <fragment v-if="!loading">
        <div class="flex flex-col mr-20 ml-20 mt-10">
            <div class="grid gap-x-8 grid-cols-1 gap-y-4 xl:grid-cols-6  ">
                <etat-bp-card :etats="etatDuBpCardData" class="xl:col-span-2" />
                <statut-juridique-card
                    :statutJuridiques="statutsJuridiqueCardData"
                    class="xl:col-span-2"
                />
                <status-card :status="statusCardData" class="xl:col-span-2" />
                <div
                    class="w-11 h-1 bg-blue-900 rounded-md mt-9 mb-6 xl:col-span-6  "
                />
                <secteur-d-activite-card
                    :secteurs="secteurDActiviteCardData"
                    class="xl:col-span-3 "
                />
                <montant-sollicite-card
                    :montants="montantSolliciteCardData"
                    class="xl:col-span-3"
                />
                <moyens-humain-card
                    :nbMoyensHumain="moyensHumainCardDataNumber"
                    class="xl:col-span-3"
                />
            </div>
        </div>
    </fragment>
</template>

<script>
import NProgress from "nprogress";
import { db } from "@/services/firebase.service";
import FormsState from "../../store/modules/forms/formsState.js";

import secteurDActiviteCard from "./components/biAnalytics/secteurDActiviteCard";
import montantSolliciteCard from "./components/biAnalytics/montantSolliciteCard";
import moyensHumainCard from "./components/biAnalytics/moyensHumainCard";
import etatBpCard from "./components/biAnalytics/etatBpCard";
import statutJuridiqueCard from "./components/biAnalytics/statutJuridiqueCard";
import statusCard from "./components/biAnalytics/statusCard";

export default {
    components: {
        secteurDActiviteCard,
        montantSolliciteCard,
        moyensHumainCard,
        etatBpCard,
        statutJuridiqueCard,
        statusCard
    },
    data() {
        return {
            totalBpis: [],
            loading: false,

            statutsJuridiqueCardData: new Map(),
            etatDuBpCardData: new Map(),
            statusCardData: new Map(),
            secteurDActiviteCardData: new Map(),
            montantSolliciteCardData: [],
            moyensHumainCardDataNumber: 0
        };
    },
    async mounted() {
        NProgress.start();
        this.loading = true;
        try {
            let bpisCollection = db.collection("bpis");
            bpisCollection = bpisCollection.where("validation", "==", true);

            const querySnapshot = await bpisCollection.get();

            for await (const doc of querySnapshot.docs) {
                const data = await db
                    .collection("bpis_output")
                    .doc(doc.id)
                    .get();

                let bpi = {
                    ...doc.data(),
                    outPut: data.data(),
                    id: doc.id
                };

                this.etatDuBpCardData.set(
                    bpi.State ? bpi.State : "Nouveau",
                    (this.etatDuBpCardData.get(
                        bpi.State ? bpi.State : "Nouveau"
                    ) || 0) + 1
                );

                this.statutsJuridiqueCardData.set(
                    bpi.entreprise_info.legalForm,
                    (this.statutsJuridiqueCardData.get(
                        bpi.entreprise_info.legalForm
                    ) || 0) + 1
                );

                this.statusCardData.set(
                    bpi.outPut.status,
                    (this.statusCardData.get(bpi.outPut.status) || 0) + 1
                );

                let secteurString =
                    FormsState.VotreProject.Sectors[bpi.project_info.activity]
                        ?.text;
                this.secteurDActiviteCardData.set(
                    secteurString,
                    (this.secteurDActiviteCardData.get(secteurString) || 0) + 1
                );

                let credits = bpi.investors_programme.creditBancaire;
                if (Array.isArray(credits)) {
                    let count = 0;
                    credits.forEach(credit => {
                        count += credit.montant;
                    });
                    this.montantSolliciteCardData.push(count);
                } else {
                    this.montantSolliciteCardData.push(credits.montant);
                }

                bpi.moyens_humains.forEach(moyenHumain => {
                    this.moyensHumainCardDataNumber += moyenHumain.value;
                });

                this.totalBpis.push(bpi);
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
            this.$emit("fetching-data", false);
            NProgress.done();
        }
    }
};
</script>

<style></style>
